// Single source of truth for the controlled vocabularies a material is
// tagged with at upload time (see UploadPanel.jsx) — reused by the Library's
// subject/level filters so they can only ever reference values that actually
// exist in the data, instead of a second, hand-maintained list drifting out
// of sync with the first.
import { FlaskConical, Dna, Atom, Calculator, Cpu, Briefcase, Landmark, HeartPulse, BookOpen } from 'lucide-react';

export const TOPICS = ['Chemistry', 'Biology', 'Physics', 'Mathematics', 'Computer Science', 'Business', 'History', 'Medicine', 'Other'];

export const EDUCATIONAL_LEVELS = ['University', 'High School', 'College', 'Master', 'PhD', 'Other'];

export const TOPIC_ICONS = {
  Chemistry: FlaskConical,
  Biology: Dna,
  Physics: Atom,
  Mathematics: Calculator,
  'Computer Science': Cpu,
  Business: Briefcase,
  History: Landmark,
  Medicine: HeartPulse,
  Other: BookOpen,
};

export const iconForTopic = (topic) => TOPIC_ICONS[topic] || BookOpen;
